import { render, staticRenderFns } from "./host-activity-live.vue?vue&type=template&id=18548e1a&scoped=true&"
import script from "./host-activity-live.vue?vue&type=script&lang=js&"
export * from "./host-activity-live.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18548e1a",
  null
  
)

export default component.exports